import { createSliceSelectors } from '../utils'

const PanoramaSelectors = createSliceSelectors('panorama', [
    'isPanoUIVisible',
    'isPanoAutoRotating',
    'panoStartLatLon',
    'isPanoramaBlurred',
    'currentXY',
    'isUserDraggingPano',
    'forceRotateParams',
])

export default PanoramaSelectors
